export const suggestThesaurus = async (
  input,
  typeThesaurusList,
  onlyDepartement,
  limit,
) => {
  const urlSearchParams = new URLSearchParams();
  if (input) {
    urlSearchParams.set('input', input);
  }
  if (onlyDepartement) {
    urlSearchParams.set('onlyDepartement', onlyDepartement);
  }
  urlSearchParams.set('limit', limit ?? 30);
  typeThesaurusList.forEach((typeThesaurus) =>
    urlSearchParams.append('typeThesaurus', typeThesaurus),
  );

  const response = await fetch(
    `${window.routes.thesaurusSuggest}?${urlSearchParams}`,
    {
      method: 'GET',
    },
  );
  if (!response.ok) {
    throw new Error(
      'Erreur lors de la récupération de suggestions de thésaurus.',
    );
  }
  return response.json();
};

const WAITING_TIME = 250;
const timeoutIdByFieldName = {};
export const debouncedSuggestThesaurus = (fieldName) => {
  return (input, typeThesaurusList, onlyDepartement, limit) => {
    return new Promise((resolve, reject) => {
      if (timeoutIdByFieldName[fieldName]) {
        window.clearTimeout(timeoutIdByFieldName[fieldName]);
      }
      timeoutIdByFieldName[fieldName] = window.setTimeout(() => {
        suggestThesaurus(input, typeThesaurusList, onlyDepartement, limit).then(
          resolve,
          reject,
        );
      }, WAITING_TIME);
    });
  };
};
